<template>
    <div>
      <section class="page-title">
            <v-img
                v-if="this.$vuetify.breakpoint.lg"
                height="320px"
                class="white--text"
                color="#f6f6f6"
                max-width="100%"
                position="center top"
                :src="require('@/Content/images/banner_pj.png')"
            >
            <div class="center" style="text-align: left">
                    <p style="color:#f25a60;" class="label-planos" >Planos Odontológicos</p>
                    <h1 style="color:#62100e" class="the-title">Planos para Servidores</h1>
                    <p style="color:#f25a60;">Temos o plano certo para cuidar da saúde bucal de toda família.</p>
                    <a @click="scrollToClass('.contrataragora')" class="button-contrate">Contratar</a>
                </div>
            </v-img>
            <v-img
                v-else
                height="300"
                class="white--text"
                max-width="100%"
                position="center top"
                :src="require('@/Content/images/banner_pj.png')"
            >
                <div class="center" style="text-align: left">
                    <p style="color:#f25a60;" class="label-planos" >Planos Odontológicos</p>
                    <h1 style="color:#62100e" class="the-title">Planos para Servidores</h1>
                    <p style="color:#f25a60;">Temos o plano certo para cuidar da saúde bucal de toda família.</p>
                    <a @click="scrollToClass('.contrataragora')" class="button-contrate">Contratar</a>
                </div>
            </v-img>
        </section>

        <section class="page-content center">
            <v-container>
              <p class="title-label" style="text-align: center; color:#62100e">Ter um plano Orale é muito simples. Siga os passos abaixo:</p>
                <v-layout row wrap center justify-center>
                  <v-row justify="center" align="center" style="padding:20px;">
                    <v-col cols="auto" class="text-center">
                      <img src="../Content/images/1.png" style="width:70px;">
                      <p style="color:#62100e; margin-top: 8px;">Escolha o órgão público <br> em que você está vinculado.</p>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center" style="padding:20px;">
                    <v-col cols="auto" class="text-center">
                      <img src="../Content/images/2.png" style="width:70px;">
                      <p style="color:#62100e; margin-top: 8px;">Escolha o plano Orale <br> que deseja.</p>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center" style="padding:20px;">
                    <v-col cols="auto" class="text-center">
                      <img src="../Content/images/3.png" style="width:70px;">
                      <p style="color:#62100e; margin-top: 8px;">Preencha os dados solicitados <br> e envie sua proposta. Pronto!</p>
                    </v-col>
                  </v-row>
                </v-layout>
                <!-- <p class="title-label">A Orale</p>
                <p>Toda evolução é feita de escolhas e a Orale optou pela qualidade. Fundada em 2000 por cirurgiões-dentistas, a empresa oferece soluções completas em assistência odontológica, tratando o cliente com carinho e dedicação.</p>
                <p>Para nós, garantir excelência em atendimento é a maior prova de respeito que podemos dar a quem nos confia a sua saúde.</p>
                <p>Nosso compromisso é assistir cada cliente de maneira especial.</p>
                <p>Conheça nossos Planos Assistenciais e garanta mais saúde e qualidade de vida para você e sua família.</p>
                <p class="title-label">Por que comprar um plano Orale?</p>
                <p>A Orale tem planos atrativos, flexíveis e acessíveis para você e sua família, confira:</p>
                <p ><strong>Agilidade</strong> -  Adesão rápida, sem burocracia, tratamentos com autorização online para a maioria dos procedimentos, Carteirinha virtual e Rede credenciada na palma de sua mão.</p>
                <p><strong>Referência em qualidade</strong> -  Nossos Planos foram classificados pelo Instituto Pró-Teste como alguns dos melhores planos odontológicos do Brasil, sendo que o Plano Ortodonzia foi considerado o melhor do Teste!</p>
                <p><strong>Ampla elegibilidade</strong> - Adesão extensiva ao grupo familiar.</p>
                <p><strong>Atendimento personalizado</strong> - Portal na Internet, área restrita ao beneficiário, Call Center e redes sociais.</p>
                <p><strong>Rede Credenciada</strong> -  Ampla rede credenciada com dentistas em todo o Brasil, acesso online à lista de dentistas credenciados, 24 horas com o conforto e a comodidade do smartphone.</p>
                <p><strong>Desconto em Farmácia</strong> -  Através da rede de drogarias credenciadas, os beneficiários Orale receberão descontos em vários medicamentos, e ainda descontos em produtos de higiene, entre outras.</p>
                <p class="title-label">Quem pode aderir?</p>
                <p>O plano ofertado é individual/familiar, podendo ser adquirido por qualquer pessoa.</p>
                <p class="title-label">Principais Coberturas (Rol da ANS)</p> -->
                <!-- <div >
                    <span class="icon"></span>
                    <p><strong>Consultas</strong> - Consultas iniciais para o plano de tratamento;</p>
                </div>
                <div >
                    <span class="icon"></span>
                    <p><strong>Urgência</strong> - Diversos procedimentos de urgência odontológica;</p>
                </div>
                <div >
                    <span class="icon"></span>
                    <p><strong>Cirurgia</strong> - Cirurgias odontológicas de pequeno porte realizada em consultórios;</p>
                </div>
                <div >
                    <span class="icon"></span>
                    <p><strong>Dentística</strong> - Restaurações e obturações em material estético (Resina) e amálgama;</p>
                </div>
                <div >
                    <span class="icon"></span>
                    <p><strong>Endodontia</strong> - Tratamento de canais;</p>
                </div>
                <div >
                    <span class="icon"></span>
                    <p><strong>Periodontia</strong> - Tratamento de gengivas;</p>
                </div>
                <div >
                    <span class="icon"></span>
                    <p><strong>Odontopediatria</strong> - Atendimento especializado para crianças;</p>
                </div>
                <div >
                    <span class="icon"></span>
                    <p><strong>Raio X</strong> - Periapical, interproximal (bite-wing), oclusal, periapical completa (levantamento radiográfico), radiografia panorâmica;</p>
                </div>
                <div >
                    <span class="icon"></span>
                    <p><strong>Próteses</strong> - Ajuste oclusal, Coroa provisória com e sem pino, Coroa total em cerômero, Coroa total metálica, Núcleo de preenchimento, Núcleo metálico fundido, Pino pré-fabricado, Remoção de trabalhos protéticos, Restauração metálica fundida;</p>
                </div>
                <div >
                    <span class="icon"></span>
                    <p><strong>Prevenção</strong> - Profilaxia / Aplicação de Flúor;</p>
                </div>
                <div >
                    <span class="icon"></span>
                    <p><strong>Exodontia</strong> - Extração, inclusive de siso incluso;</p>
                </div>
                <div>
                    <span class="icon"></span>
                    <p><strong>Ortodontia</strong> -  Documentação ortodôntica, Instalação e manutenção de aparelho metálico fixo (Verificar planos que incluem esta cobertura);</p>
                </div>
                <div >
                    <span class="icon"></span>
                    <p><strong>Implantes</strong> - Implantes Unitários, Coroa metalo-cerâmica sobre implantes, Prótese Protocolo total híbrida sobre Implantes (verificar planos que incluem esta cobertura);</p>
                </div>
                <div>
                    <p>Para acessar a cobertura do Rol da ANS, <a href="http://www.orale.com.br/emkt/rol_procedimentos.pdf" target="_blank">clique aqui.</a></p>
                </div> -->
                <!-- <p class="title-label">Carências</p>
                <p>Somente alguns planos da Orale possuem carências. Carência é o prazo ininterrupto, em que o beneficiário não goza do direito de utilizar da cobertura do plano contratado, sendo este prazo contado da data de aceitação da Proposta de Adesão, que está entendida data de início de vigência do beneficiário.</p> -->
                <!--<table class="table-carencia" cellpadding="0" cellspacing="0" border="0">
                    <tr>
                        <th></th>
                        <th colspan="1">Carências</th>
                    </tr>
                    <tr class="mini-header">
                        <td>Procedimentos</td>
                        <td class="carencia">Plano Individual/Familiar</td>
                    </tr>
                    <tr>
                        <td>Consulta de Urgência</td>
                        <td class="carencia">24 horas</td>
                    </tr>
                    <tr>
                        <td>Consulta inicial, Radiologia, Prevenção</td>
                        <td class="carencia">24 horas</td>
                    </tr>
                    <tr>
                        <td>Odontopediatria, Periodontia, Dentística, Cirurgia Oral Menor</td>
                        <td class="carencia">24 horas</td>
                    </tr>
                    <tr>
                        <td>Endodontia</td>
                        <td class="carencia">120 dias</td>
                    </tr>
                    <tr>
                        <td>Prótese</td>
                        <td class="carencia">180 dias</td>
                    </tr>
                </table> -->
                <div class="contrataragora"> 
                    <v-fade-transition mode="out-in">
                        <div class="exibelocalizacao" v-if="exibeLocalizacao">
                            <div class="planos-wrapper">
                                <p class="planos-title" style="margin-bottom: 35px"><strong>Orgão Averbador</strong></p>
                                <v-layout align-center>
                                    <v-flex xs12 sm12>
                                        <v-card flat max-height="400px" max-width="600px" class="mx-auto localizacao" style="border: 1px solid; border-color: #ED1C24;border-radius: 10px;">
                                            <v-card-text>
                                                <v-container grid-list-md>                                  
                                                    <v-layout align-center justify-center row wrap>                                        
                                                        <v-flex xs12 sm12 lg10>
                                                            <v-autocomplete
                                                                id="comboOrgao"               
                                                                v-model="idOrgao"
                                                                item-value="id"
                                                                item-text="orgao"
                                                                :items="orgaosAverbadores"
                                                                label="Orgão Averbador"
                                                                placeholder="Digite para pesquisar..."
                                                                color="#ED1C24"
                                                            ></v-autocomplete>
                                                        </v-flex>
                                                        <v-layout align-center justify-center row wrap>
                                                            <v-flex xs12 sm6 md6 lg6>
                                                                <v-btn style="border-radius: 6px;" large dark @click="controlaExibicaoPlanos()" color="#ED1C24">Consultar Planos</v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-layout>
                                                </v-container>
                                            </v-card-text>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </div>
                        <div class="exibeplanos" v-else>
                            <div class="planos-wrapper">
                                <p class="planos-title"><strong>Orgão Averbador: {{this.nomeOrgao}}</strong>
                                    <v-btn icon small dark @click.prevent="exibeLocalizacao = !exibeLocalizacao" color="#ED1C24">
                                        <v-icon small style="margin-right: 0%;">cached</v-icon>
                                    </v-btn>
                                </p>
                                <br>
                                <p class="textoEscolha"><strong>Escolha o melhor plano Orale para sua família!</strong></p>
                                <!-- <p class="planos-title">INDIVIDUAL ANUAL</p> -->
                                <v-container grid-list-md>
                                    <v-layout row wrap justify-center>
                                        <v-flex v-for="plano in planos" :key="`3${plano.id}`" xs12 sm12 md6 lg4>
                                            <div class="list-planos">
                                                <div class="item">
                                                    <!-- <h6 class="dePara">De</h6>
                                                    <p class="priceOld"><span>R$</span> {{plano.oldValue}}<br></p>
                                                    <h6 class="dePara">Por</h6> -->
                                                    <div class="boleto" style="margin-bottom: 20px">{{plano.name}}</div>
                                                    <p class="price" style="margin-bottom: 20px"><span style="margin-right: 5px">R$</span>{{plano.value.split(",")[0]}}<span>,{{plano.value.split(",")[1]}} / pessoa</span></p>
                                                    <p class="cobertura" style="font-weight: bold"><span>{{plano.typePayment}}</span></p>
                                                    <a @click="contratoSP(plano)" class="button">Contratar plano</a>
                                                </div>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </div>
                        </div>
                    </v-fade-transition>
                </div>
            </v-container>
        </section>
        <v-dialog v-model="dialog" max-width="700px" max-height="400px">
            <v-card>
                <v-container grid-list-md>
                    <v-layout row wrap justify-center>
                        <v-card-title>
                            <span class="total">Prezado(a) cliente,</span>              
                        </v-card-title>
                        <v-container fluid pa-1 justify-center class="resumo">
                            <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a  segurança e a tranquilidade que você precisa.</p>
                            <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
                            <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
                            <br>
                            <p class="resumo" style="font-weight: bold">A <span style="color:#ED1C24">Orale</span> agradece a sua atenção !</p>
                            <br>
                            <p class="resumo" style="font-weight: bold;color:#ED1C24">Termo de Privacidade, <a href="https://orale.intelite.com.br/contratosOrale/docs/Politica_de_Privacidade_Orale_LGPD.pdf" target="_blank">clique aqui.</a></p>
                            <v-checkbox v-model="contrataccept" color="#ED1C24">
                                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da Orale.</span>
                            </v-checkbox>
                        </v-container>
                    </v-layout>
                    <v-card-actions>
                        <v-container fill-height fluid pa-1 justify-center>
                            <br>
                            <v-btn @click="confirmaPlano()" color="#ED1C24" depressed style="border-radius: 8px; width: 130px;color: white;">Continuar</v-btn>
                        </v-container>
                    </v-card-actions>
                </v-container>
            </v-card>
        </v-dialog>
        <Snackbar ref=chamaSnackbar />
    </div>
</template>

<script>
    import Snackbar from '../components/snackbar.vue'
    import axios from 'axios'
    import { baseApiUrl } from '@/global'
    export default {
        components: {Snackbar},
        data() {
            return {
                desconto: '',
                idOrgao: '',
                abrangenciaOrgao: '',
                abrangenciaId: '',
                nomeOrgao: '',
                exibeLocalizacao: true,
                planos: [],
                vendedor: [],
                planoSelecionado: [],
                orgaosAverbadores: [],
                contrataccept: false,
                dialog: false,
            };
        }, 

        /* watch: {
            'estado': function () {
                this.cidades = brasil[this.estado].cidades
            }
        }, */

        mounted : function() {
            localStorage.clear()
            sessionStorage.clear() 
            this.pegaParametrosUrl() 
            this.$store.dispatch('ExibeToolbar')
            this.exibeLocalizacao = true;
            this.$store.dispatch('Logar')
            this.carregaOrgaos()
        },

        methods: {
            scrollToClass(className) {
                // Get the first element with the given class name
                let el = this.$el.querySelector(className)
                // Get the bounding rectangle so we can get the element position position
                let rect = el.getBoundingClientRect()
                // Scroll to the element (using x and y axis)
                window.scrollTo(rect.left, rect.top)
            },

            scrollbotton() {
                window.scrollTo(0, 3000)
            },
        
            async carregaOrgaos() {
                this.idOrgao = ''
                await axios.get(`${baseApiUrl}OrgaoAverbadors/listaPublicaAtivos`).then(res => {        
                    if (res.data != null) {
                        this.orgaosAverbadores = res.data

                        this.orgaosAverbadores.sort((a, b) => {
                        return a.orgao.localeCompare(b.orgao);
                        });
                    }
                })
            },

            async controlaExibicaoPlanos() {
                if ((this.idOrgao == '')) {
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("warning","Selecione o Orgão Averbador")
                } else {
                    for (var i=0; i<this.orgaosAverbadores.length; i++) {
                        if (this.orgaosAverbadores[i].id === this.idOrgao) {
                            this.nomeOrgao = this.orgaosAverbadores[i].orgao
                            this.abrangenciaOrgao = this.orgaosAverbadores[i].abrangenciaId
                            this.abrangenciaId = this.orgaosAverbadores[i].id
                        }
                    }

                    // 1. Busca os planos ESPECÍFICOS do órgão averbador
                    let planosEspecificos = await this.pegaPlanosOrgaoAverbador(this.idOrgao);

                    // 2. Busca os planos GERAIS da abrangência
                    let planosGerais = [];
                    try {
                        let response = await axios.get(`${baseApiUrl}Plans/listaPublica?publico=${encodeURIComponent('Servidor')}&abrangenciaId=${encodeURIComponent(this.abrangenciaOrgao)}&qualificacao=${encodeURIComponent('Individual,Familiar')}`);                        
                        if (response.data != null) {
                            // Filtro de segurança: Garante que os "gerais" são apenas aqueles sem orgaoAverbadorIds (ou lista vazia)
                            planosGerais = response.data.filter(p => !p.orgaoAverbadorIds || p.orgaoAverbadorIds.length === 0);
                        }
                    } catch (error) {
                        console.error("Erro na busca da API:", error);
                    }

                    // 3. Soma as duas listas (Os "de antes" + Os exclusivos)
                    let todosOsPlanos = [...planosEspecificos, ...planosGerais];

                    // 4. Tira possíveis duplicatas
                    this.planos = todosOsPlanos.filter((plano, index, self) =>
                        index === self.findIndex((p) => p.id === plano.id)
                    );

                    this.exibeLocalizacao = false;
                }
            },

            async pegaPlanosOrgaoAverbador(orgaoAverbadorId) {
                let planosLocalizados = []

                await axios.get(`${baseApiUrl}Plans/listaPublica?publico=${encodeURIComponent('Servidor')}&abrangenciaId=${encodeURIComponent(this.abrangenciaOrgao)}&qualificacao=${encodeURIComponent('Individual,Familiar')}`)
                  .then(response => {
                      planosLocalizados = (response.data || []).filter(p => String(p.orgaoAverbadorIds || '').includes(String(orgaoAverbadorId)))
                  })

                return planosLocalizados
            },

            contratoSP(plano) {
                /* if(this.contrataccept) { */
                    localStorage.clear()
                    sessionStorage.clear()
                    this.planoSelecionado = plano
                    this.$store.dispatch('planosSP', this.planoSelecionado)
                    sessionStorage.setItem('orgaoAverbadorId',this.abrangenciaId)
                    localStorage.setItem('planoSelecionado',JSON.stringify(this.planoSelecionado))
                    if (this.vendedor != '')
                        sessionStorage.setItem('Vendedor',JSON.stringify(this.vendedor)) 
                    this.$router.push({ path: '/contratosp' })
                /* } else {
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Para continuar, é necessário concordar com os termos de privacidade!","ATENÇÃO")
                } */
            },

            /* contratoSP(plano) {
                this.dialog = true
                this.planoSelecionado = plano            
            }, */

            calculaDesconto(plano) {
                var desconto = parseFloat(plano.oldValue.replace(',', '.')) - parseFloat(plano.value.replace(',', '.'))
                //desconto = desconto.replace('.','.')  
                return desconto.toFixed(2).replace('.',',')
            },

            async pegaParametrosUrl() {
                var params = window.location.search.substring(1).split('&');
                if (params[0] != '') {
                    //Criar objeto que vai conter os parametros
                    var paramArray = {};
                    //Passar por todos os parametros
                    for (var i=0; i<params.length; i++) {
                        //Dividir os parametros chave e valor
                        var param = params[i].split('=');
                        //Adicionar ao objeto criado antes
                        paramArray[param[0]] = param[1];
                    }
                    if (paramArray['vendedor']) {
                        await axios.get(`${baseApiUrl}Salesmans/infoPublico?linkSite=${paramArray['vendedor']}`).then(res => {
                            if (res.data != null) {
                                //console.log(res.data[0])
                                this.vendedor = res.data
                            }
                        })
                    }
                }
            },
        }
    }
</script>

<style>
    .localizacao {
        border: 1px solid;
        border-color: #ED1C24;
    }
    
    .planos-wrapper .list-planos .item .priceOld {
        margin-bottom: -10px;
        font-weight: 700;
        font-size: 30px;
        line-height: 34px;
        color: #ED1C24;
        text-align: center;
        text-decoration: line-through;
    }

    .planos-wrapper .list-planos .item .priceOld span {
        margin-bottom: -10px;
        font-size: 15px;
        font-weight: 300;
        color: #666;
        position: relative;
        top: -15px;
        margin-right: -5px;
    }

    .dePara {
        margin-bottom: -10px;
        font-weight: 400;
        font-size: 15px;
        line-height: 37px;
        color: #ED1C24;
        text-align: center; 
    }

    .planos-wrapper .list-planos .item .price {
        margin-bottom: -5px;
        font-weight: 700;
        font-size: 45px;
        line-height: 37px;
        color: #ED1C24;
        text-align: center;
    }
    
    .desconto {
        text-align: center;
        margin-bottom: 5px;
        font-size: 15px;
        font-weight: 300;
        color: #666;
        position: relative;
        top: -15px;
        margin-right: -10px;
    }

    .textoEscolha {
        font-size: 25px;
        line-height: 26px;
        text-align: center;
        color: #ED1C24;
        text-transform: uppercase;
    }
</style>
